import React from "react"
import { Form, Select } from "antd"
import { faRobot } from "@fortawesome/free-solid-svg-icons"
import DataQButton from "shared/ui/Buttons/DataQButton.component"
import FormatPanelHeader from "./FormatPanelHeader.component"
import { InputValues } from "features/QueryConsole/api/useExportDataModal"
import { JSONL_FLAT_SEPARATOR } from "types/engineExport.types"

interface JsonlExportPanelProps {
  inputValues: InputValues
  onInputChange: <K extends keyof InputValues>(
    key: K,
    value: InputValues[K],
  ) => void
  onExport: () => Promise<void>
  isExporting: boolean
}

const JsonlExportPanel: React.FC<JsonlExportPanelProps> = ({
  inputValues,
  onInputChange,
  onExport,
  isExporting,
}) => (
  <div className="flex flex-col">
    <FormatPanelHeader
      icon={faRobot}
      title="Export as JSONL"
      tagLabel="AI/ML"
      tagColor="purple"
      description="One JSON object per respondent per line. Includes schema file. Optimized for AI/ML pipelines, NoSQL databases, and streaming."
    />
    <Form layout="vertical">
      <Form.Item label="Value Format">
        <Select
          value={inputValues.jsonlUseLabels}
          onChange={(value: boolean) => onInputChange("jsonlUseLabels", value)}
          options={[
            { value: false, label: "Codes (1, 2, 3)" },
            { value: true, label: "Labels (Male, Female, ...)" },
          ]}
        />
      </Form.Item>
      <Form.Item label="Structure">
        <Select
          value={inputValues.jsonlFlatSeparator}
          onChange={(value: JSONL_FLAT_SEPARATOR) =>
            onInputChange("jsonlFlatSeparator", value)
          }
          options={[
            {
              value: JSONL_FLAT_SEPARATOR.NONE,
              label: "Hierarchical (nested)",
            },
            {
              value: JSONL_FLAT_SEPARATOR.DSLASH,
              label: 'Flat - separated by " // " (Coming Soon)',
              disabled: true,
            },
            {
              value: JSONL_FLAT_SEPARATOR.PIPE,
              label: 'Flat - separated by " | " (Coming Soon)',
              disabled: true,
            },
            {
              value: JSONL_FLAT_SEPARATOR.DASH,
              label: 'Flat - separated by " - " (Coming Soon) ',
              disabled: true,
            },
          ]}
        />
      </Form.Item>
    </Form>
    <div className="border-t border-gray-100 pt-4 mt-1">
      <DataQButton
        type="primary"
        onClick={onExport}
        isLoading={isExporting}
        aria-label="Export data as JSONL file"
      >
        Export JSONL
      </DataQButton>
    </div>
  </div>
)

export default JsonlExportPanel
